<template>
  <div>
    <el-form
      :model="formData"
      :rules="rules"
      ref="form"
      class="main-form-scroll"
    >
      <el-form-item :label="$t('section.name')" prop="nameSelected">
        <el-input v-model="formData.nameSelected"></el-input>
      </el-form-item>
      <el-form-item :label="$t('section.alias')" prop="aliasSelected">
        <el-input v-model="formData.aliasSelected"></el-input>
      </el-form-item>
      <el-form-item :label="$t('section.path')" prop="pathSelected">
        <el-input v-model="formData.pathSelected"></el-input>
      </el-form-item>
      <el-form-item :label="$t('section.server')" prop="serverSelected">
        <el-select
          v-model="formData.serverSelected"
          v-if="!serverParent"
          filterable
          :placeholder="$t('section.serverNotSelected')"
        >
          <el-option
            v-for="(server, index) in getServersArray"
            :key="index"
            :value="server.id"
            :label="server.name"
          ></el-option>
        </el-select>

        <b v-else>{{ serverParent }}</b>
      </el-form-item>
      <el-form-item :label="$t('section.appType')" prop="apiSelected">
        <el-select
          v-model="formData.apiSelected"
          filterable
          :placeholder="$t('section.appTypeNotSelected')"
        >
          <el-option
            v-for="api in getTypeApi"
            :key="api.typeApiID"
            :label="api.typeApiName"
            :value="api.typeApiID"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="webAppSelected">
        <el-checkbox v-model="formData.webAppSelected">{{
          $t("section.appBelongsWeb")
        }}</el-checkbox>
      </el-form-item>
    </el-form>
    <div slot="footer" class="bottom-buttons">
      <div></div>
      <div>
        <el-button class="button-cancel" type="plain" @click="cancelClick">{{
          $t("section.cancel")
        }}</el-button>
        <el-button class="button-confirm" type="success" @click="okClick"
          >OK</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    const validateName = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("section.enterAppName")));
      } else if (value.trim().includes(" ")) {
        callback(new Error(this.$t("errors.nameHasSpace")));
      } else {
        callback();
      }
    };
    const validatePath = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("section.enterAppPath")));
      } else if (value.trim().includes(" ")) {
        callback(new Error(this.$t("errors.nameHasSpace")));
      } else {
        callback();
      }
    };
    return {
      formData: {
        nameSelected: null,
        aliasSelected: null,
        pathSelected: null,
        serverSelected: null,
        apiSelected: null,
        webAppSelected: false,
      },
      rules: {
        nameSelected: [
          {
            required: true,
            validator: validateName,
            trigger: "blur",
          },
        ],
        aliasSelected: [{ required: false }],
        pathSelected: [
          {
            required: true,
            validator: validatePath,
            trigger: "blur",
          },
        ],
        serverSelected: [
          {
            required: true,
            message: this.$t("section.enterAppServer"),
            trigger: "change",
          },
        ],
        apiSelected: [
          {
            required: true,
            message: this.$t("section.enterAppType"),
            trigger: "change",
          },
        ],
        webAppSelected: [{ required: false }],
      },
      serverParent: null,
    };
  },
  props: {
    type: String,
    fromReference: Boolean,
  },
  computed: {
    ...mapGetters([
      "getParentServerId",
      "getServersArray",
      "getTypeApi",
      "getCurInfo",
    ]),
  },

  methods: {
    populateForm() {
      this.formData.nameSelected = this.getCurInfo.name;
      this.formData.aliasSelected = this.getCurInfo.alias;
      this.formData.apiSelected = this.getCurInfo.idTypeAPI;
      this.formData.pathSelected = this.getCurInfo.path;
      this.formData.serverSelected = this.getCurInfo.idServer;
      this.formData.webAppSelected =
        this.getCurInfo.webApp === "0" ? false : true;
    },
    okClick() {
      for (let index in this.formData) {
        if (
          this.formData[index] != null &&
          typeof this.formData[index] === "string"
        ) {
          this.formData[index] = this.formData[index].trim();
        }
      }
      this.$refs["form"].validate((valid, object) => {
        if (valid) {
          this.$emit("data", this.formData);
        } else {
          this.$message.error(this.$t("errors.notAllRequiredFieldsSelected"));
        }
      });
    },
    cancelClick() {
      this.$emit("close");
    },
  },
  created() {
    if (this.type === "add") {
      //текущий сервер, с которого была вызвана форма добавления приложения
      if (this.getParentServerId && !this.fromReference) {
        this.formData.serverSelected = this.getParentServerId;
        this.serverParent = this.getServersArray.find(
          (element) => element.id === this.getParentServerId
        ).name;
      } else if (this.fromReference) {
        this.serverParent = null;
      } else this.$store.commit("setError", "No server selected");
    } else if (this.type === "edit") {
      this.populateForm();
    }
  },
};
</script>

<style scoped>
</style>